import styled from '@emotion/styled';
import { type FC, useState } from 'react';
import { useTrackersForAction } from '../../../lib/customHooks';
import { TrackerLogisticsModal } from '../TrackerLogisticsModal';

export const ChangeLogisticsButton: FC = () => {
  const [show, setShow] = useState(false);
  const trackersToUse = useTrackersForAction();
  const trackerIdsToUse = trackersToUse != null ? trackersToUse.map((t) => t.id) : [];

  return (
    <>
      <Container onClick={() => setShow(true)}>
        <div>Logistics</div>
      </Container>
      <TrackerLogisticsModal
        trackerIds={trackerIdsToUse}
        show={show}
        onClose={() => setShow(false)}
      />
    </>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
`;
